module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-lg carrier-account\"> <div class=\"modal-content\"> <div class=\"modal-header\"> <h4 class=\"modal-title\">Add Your ")
    ; __append(escapeFn( locals.readable ))
    ; __append(" Account</h4> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> </div> <form> <section class=\"modal-body\"> <div class=\"mb-5\"> ")
    ;  if(locals.autoLink) { 
    ; __append(" <h6>EasyPost automatically connects with ")
    ; __append(escapeFn( locals.readable ))
    ; __append(" accounts</h6> ")
    ;  } else { 
    ; __append(" <h6>Please enter your ")
    ; __append(escapeFn( locals.readable ))
    ; __append(" credentials</h6> ")
    ;  } 
    ; __append(" </div> <div class=\"form-group row\"> <label class=\"col-sm-4 control-label\" for=\"carrier_account_reference\">Reference</label> <div class=\"col-sm-8\"> <input class=\"form-control\" id=\"carrier_account_reference\" name=\"carrier_account_reference\" type=\"text\" placeholder=\"(Optional) Enter a custom reference. This cannot be edited once filled.\"> </div> </div> <div class=\"form-group row\"> <label class=\"col-sm-4 control-label\" for=\"carrier_account_description\">Description</label> <div class=\"col-sm-8\"> <input class=\"form-control\" id=\"carrier_account_description\" name=\"carrier_account_description\" type=\"text\" placeholder=\"Please enter a custom description.\"> </div> </div> ")
    ;  if (locals.hasCredentials) { 
    ; __append(" <hr> <div id=\"credential_management\"></div> ")
    ;  } 
    ; __append(" ")
    ;  if (locals.hasTestCredentials) { 
    ; __append(" <h6 class=\"text-center\">Please enter your test credentials</h6> <div id=\"test_credential_management\"></div> ")
    ;  } 
    ; __append(" </section> <section class=\"modal-footer\"> <button class=\"btn btn-secondary create_account\" type=\"submit\">Create</button> <button class=\"btn btn-clear cancel\" type=\"button\">Cancel</button> </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/create_carrier_account_modal.ejs
// module id = 1327
// module chunks = 1